/* eslint-disable no-template-curly-in-string */
import { object, string, StringSchema } from 'yup';

export const employeeValidationSchema = (isUpdate: boolean) => object().shape({
    email: string()
        .email()
        .required('Required'),
    firstName: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required(),
    lastName: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required(),
    pin: string()
        .min(4)
        .max(6)
        .optional(),
    password: isUpdate 
        ? string()
            .min(6)
            .optional()
        : string()
            .min(6)
            .required(),
    defaultVenueId: string()
        .optional()
        .when(
            ['venueIds'], (venueIds: { id: string; name: string }[], schema: StringSchema, { originalValue }: { originalValue: string }
            ) => {
                const found = !!venueIds.find(venue => venue.id === originalValue);
                if(!found){
                    return schema.typeError('Venue mismatch');
                }
                return schema;
            })
});
